export default "__VITE_ASSET__Ci18f98$__"